import React, { Component } from 'react'
import { Link, browserHistory } from 'react-router';
import { Col, Nav, Button, NavItem, NavDropdown, MenuItem } from 'react-bootstrap';

import { LinkContainer } from 'react-router-bootstrap';
import { Parser } from 'html-to-react';
import Zoom from 'react-reveal/Zoom';
import { fadeInLeft } from 'react-animations';

import Radium, {StyleRoot} from 'radium';
import { Bounce, Shake } from 'react-motions'





class Sidebar extends Component {
	render() {
    const { t } = this.props;
		return (

	
      <div className="col-md-4 sidebar">
      <div className="sidebar-widget">
                           {/* <h5>Green Agro Business c'est :</h5>
                            <hr/> */}
                            <ul className="widget-post">
                            <h5>Green Agro Business c'est :</h5>
                                <li>
                                    <a className="widget-post-media">
                                        <img src="/assets/img/images/new_images/worker.png" className="agronom"/>
                                    </a>
                                    <div className="widget-post-info">
                                        <h6 className="color-white"><a>Techniciens conseils</a></h6>
                                        
                                    </div>
                                </li>
                                <li>
                                    <a className="widget-post-media">
                                        <img src="/assets/img/images/new_images/industry.png" className="agronom"/>
                                    </a>
                                    <div className="widget-post-info">
                                        <h6><a>1 Usine de 70 000 t de capacité</a></h6>
                                        
                                    </div>
                                </li>
                                <li>
                                    <a className="widget-post-media">
                                        <img src="/assets/img/images/new_images/hands.png" className="agronom"/>
                                    </a>
                                    <div className="widget-post-info">
                                        <h6><a>Partenariats solides</a></h6>
                                        
                                    </div>
                                </li>
                                <li>
                                    <a className="widget-post-media">
                                        <img src="/assets/img/images/new_images/group.png" className="agronom"/>
                                    </a>
                                    <div className="widget-post-info">
                                        <h6><a>+ 150 emplois directs<br/> + 1000 emplois indirects</a></h6>
                                        
                                    </div>
                                </li>


                            </ul>
                        </div>

                {/*<div className="side_chiffres" >
                                <h5>Green Agro Business c'est :</h5>
                                      <Zoom top cascade>
                                        <div className="side_animations" >
                                        
                                            <div><img src="/assets/img/images/new_images/worker.png" className="agronom"/></div>
                                            <span className="sidebar_text">Techniciens conseils</span>
                                             
                                        </div>
                                     </Zoom>
                                   
                
                                  <Zoom top cascade>
                                    <div className="side_animations" >
                                        <div>
                                            <div><img src="/assets/img/images/new_images/industry.png" className="agronom"/></div>
                                            <span className="sidebar_text">1 Usine de 70 000 t de capacité</span>
                                        </div>
                                    </div>
                                     </Zoom>
                
                
                                   <Zoom top cascade>
                                    <div className="side_animations" >
                                        <div>
                                            <div><img src="/assets/img/images/new_images/hands.png" className="agronom"/></div>
                                            <span className="sidebar_text">Partenariats solides</span>
                                        </div>
                                    </div>
                                    </Zoom>
                
                                    <Zoom top cascade>
                                    <div className="side_animations" >
                                        <div>
                                            <div><img src="/assets/img/images/new_images/group.png" className="agronom"/></div>
                                            <span className="sidebar_text">+150 emplois<br/> + 1000 emplois indirects</span>
                                        </div>
                                    </div>
                                   </Zoom>
                    </div>*/}
    </div>
		)
	}
}

export default (Sidebar);


// WEBPACK FOOTER //
// ./src/components/Sidebar.jsx